import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const ColorSelectionContainer = styled.div`
  display: flex;
  flex-direction: ${props => (props.size === "small" ? "row" : "column")};
  align-items: center;
  justify-content: center;
  flex: unset !important;
  padding-top: 15px;
  .row {
    display: flex;
    margin-bottom: ${props => (props.size === "small" ? "16px" : "24px")};
    margin-left: ${props => (props.size === "small" ? "12px" : "0")};
  }
  .error {
    color: ${Variables.colors.red_600};
    font-size: ${Variables.font_sizes.medium};
    margin-bottom: 10px;
  }
`;

export const ColorContainer = styled.div`
  width: ${props => (props.size === "small" ? "32px" : "54px")};
  height: ${props => (props.size === "small" ? "32px" : "54px")};
  border-radius: 50%;
  background-color: ${props => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: ${props => (props.size === "small" ? "12px" : "32px")};
  cursor: pointer;
  &:last-child {
    margin-left: 0;
  }
  .selected-color-icon {
    color: ${Variables.colors.complementary};
  }
`;
